import P from '@leverege/promise';
import Path from '@leverege/path';
import { Config } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import { ValuesCache } from '@leverege/value-cache';
import { Attributes, ExportIterator, DataSources } from '@leverege/ui-attributes';
import { ItemDelegate } from '@leverege/molten-core';
import ParentUtil from "../../../../imagine/attributes/parent/ParentUtil.js";
import FilterSourcesModel from "../../../../filters/FilterSourcesModel.js";
export default class ApiServerItemIterator extends ExportIterator {
  constructor(opts) {
    super();
    const {
      api,
      url,
      perPage,
      filters,
      delegate,
      ...rest
    } = opts;
    this.delegate = delegate;
    this.perPage = opts.perPage || 1000;
    this.filters = filters;
    this.options = rest;
    this.offset = 0;
    this.relationshipCache = new ValuesCache();
    this.isInError = false;
  }
  createDataItems = item => {
    const dataRef = {
      id: item.id,
      ref: this.options.ref,
      type: this.options.objectType
    };
    const obj = DataSources.withData(dataRef);
    if (obj.data == null) {
      obj.data = item;
    }
    return JSON.parse(JSON.stringify(obj));
  };
  async next(fields, retries = 5) {
    if (this.hasNext()) {
      let q;
      // this is an attempt to make export work with a sort as much as possible
      // until the ES lib/api-server can be fixed
      if (this.nextToken && this.offset + this.perPage > Config.get('DeviceList', 'maxOffset', 9999)) {
        q = {
          nextToken: this.nextToken,
          limit: this.perPage,
          filter: FilterSourcesModel.getFilter(this.filters) || null,
          sort: FilterSourcesModel.getSort(this.filters) || null,
          queryName: 'dataExport'
        };
      } else {
        q = {
          offset: this.offset,
          limit: this.perPage,
          filter: FilterSourcesModel.getFilter(this.filters) || null,
          sort: FilterSourcesModel.getSort(this.filters) || null,
          queryName: 'dataExport'
        };
      }
      try {
        const res = await GlobalState.dispatch(this.delegate.search(q));
        this.nextToken = res?.nextToken;
        this.offset = this.getOffset(res);
        let dataItems = res.items.map(this.createDataItems);
        dataItems = await this.populateParentRelationships(dataItems, fields);
        return dataItems;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        if (retries > 0 && err.status < 500 && err.status >= 400) {
          return this.next(fields, retries - 1);
        }
        this.isInError = true;
        throw err;
      }
    }
    return null;
  }
  hasNext() {
    return this.offset !== null && !this.isInError;
  }
  populateParentRelationships(items, fields) {
    const parentRelationshipFields = fields.filter(field => field.type === 'attr.exportField.parentRelationship');
    return P.mapLimit(items, async item => {
      const nItem = {
        ...item
      };
      if (parentRelationshipFields.length > 0) {
        for (let i = 0; i < parentRelationshipFields.length; i++) {
          const field = parentRelationshipFields[i];
          const attr = Attributes.getAttribute(field.attrName, field.objectType);
          if (attr?.blueprint?.updatePath) {
            const val = attr.get(nItem.data);
            try {
              // eslint-disable-next-line no-await-in-loop
              const relVal = await this.getParentRelValue(item, attr, val);
              if (relVal) {
                Path.set(attr.blueprint.updatePath, nItem.data, relVal);
              }
            } catch (err) {
              // eslint-disable-next-line no-console
              console.error(err);
            }
          }
        }
      }
      return nItem;
    }, {
      limit: 5
    });
  }
  async getParentRelValue(item, attr, val) {
    const action = ParentUtil.getParentAction(item, attr);
    const labelAttribute = attr?.blueprint?.attribute?.metadata?.setter?.labelAttribute || 'name';
    if (action && val) {
      let device = ItemDelegate.getItem(val);
      device = device || (await GlobalState.dispatch(action.item(val).get({
        ttl: 30000
      })));
      return Attributes.get(labelAttribute, action.relationship?.blueprint?.type, device) || device?.name || device?.id;
    }
    return val;
  }
  getOffset(res) {
    if (res.total > res.perPage + res.offset) {
      return res.offset + res.perPage;
    }
    return null;
  }
}